import { render, staticRenderFns } from "./CoreCard.vue?vue&type=template&id=6ba8d9c5&scoped=true"
import script from "./CoreCard.vue?vue&type=script&lang=js"
export * from "./CoreCard.vue?vue&type=script&lang=js"
import style0 from "./CoreCard.vue?vue&type=style&index=0&id=6ba8d9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8d9c5",
  null
  
)

export default component.exports